<template>
  <LayoutHeader main="play" :loadingOverlay="loadingOverlay" :me="me" ref="layout" googleContext="play">
    <article ref="article">
      <div class="playWrap" ref="playWrap">
        <div class="playContainer" id="gamePlayContainer" ref="playContainer">
        </div>
      </div>
      <div class="debugLog" :class="{'rightDebugLog': rightDebugLog}" v-if="showDebugLog" ref="debugLog" @dblclick="rightDebugLog = !rightDebugLog" @dbltap="rightDebugLog = !rightDebugLog">
        <pre ref="debugLogLines"><code>{{ debugLogs.join("\n") }}</code></pre>
      </div>
      <div class="scrollUpGuide" ref="scrollUpGuide" v-if="gesturecompleted || firstframearrived">
        <div class="touch"></div>
        <div class="text">上にスワイプで拡大</div>
      </div>
    </article>
    <template v-slot:header>
      <!-- <div class="headerXenoPr">只今キャンペーン中! 今ならTapFunでアイテムが10%OFF (Uコイン除く) ※期間は<a href="https://x.com/PROJECTXENO_JP" target="_blank">公式X</a>を参照</div> -->
      <!-- [ status: {{ this.onnineStatus }} / error: {{ this.onnineError }} ] -->
    </template>
    <template v-slot:controls>
      <div class="controls">
        <template v-if="gesturecompleted || firstframearrived">
          <div class="restart">
            <a href="javascript:;" @click="restart()"><i class="fa-sharp fa-light fa-rotate-left"></i><span class="portraitHidden"> 再起動</span></a>
          </div>
          <div class="fullscreen">
            <a href="javascript:;" @click="fullscreen()"><i class="fa-sharp fa-regular fa-expand"></i> 全画面</a>
          </div>
        </template>
        <div class="appHistories">
          <template v-if="appHistory" v-for="v in appHistory">
            <router-link v-if="v.path !== ''" class="appHistory" :to="{ name: 'Play', params: { app: v.path }}"><img :src="v.icon" /></router-link>
          </template>
        </div>
      </div>
    </template>
    <template v-slot:left>
      <aside class="left">
        <div class="logo">
          <router-link to="/">
            <img :src="'/assets/favicon-128x128.png'" />
          </router-link>
        </div>
        <div class="navigations" v-if="me">
          <router-link class="account" :to="{ name: 'Account' }" :title="me.email"><i class="fa-regular fa-user"></i></router-link>
        </div>
        <div class="navigations" v-if="me === false">
          <div class="register">
            <a href="javascript:;" @click.prevent="registerModal = true"><i class="fa-regular fa-user-plus"></i></a>
          </div>
          <div class="login">
            <a href="javascript:;" class="login" @click.prevent="$refs.layout.showLoginModal()"><i class="fa-regular fa-right-to-bracket"></i></a>
          </div>
        </div>
      </aside>
    </template>
    <div v-if="noAvailableSlot" class="noAvailableSlot">
      <div>サーバーが混雑中です。しばらくお待ち下さい ...</div>
    </div>
    <div v-if="onnineNotFound" class="onnineNotFound">
      <div>現在クラウドゲーミングサーバーのメンテナンス中です。少しお時間をおいてから、再度お試しください。</div>
    </div>
    <div v-if="appMaintenance && app" class="appMaintenance">
      <div>現在「{{ app.title }}」はメンテナンス中です。少しお時間をおいてから、再度お試しください。</div>
    </div>
    <div v-if="idledisconnect" class="idledisconnect">
      <div>
        <div clasS="mb-2">長時間操作がなかったため、ゲームを終了しました。</div>
        <div>
          <a clasS="btn btn-dark" href="javascript:;" @click="restart(false)">ゲームを再起動する</a>
        </div>
      </div>
    </div>
    <div v-if="stopped" class="idledisconnect">
      <div>
        <div clasS="mb-2">ゲームが終了しました。</div>
        <div>
          <a clasS="btn btn-dark" href="javascript:;" @click="restart(false)">ゲームを再起動する</a>
        </div>
      </div>
    </div>
    <Modal v-model="purchaseModal" :title="purchaseModalTitle" @closing="purchaseModalClose" v-if="me && app && purchaseData" modalClass="purchaseModal">
      <div class="item" v-if="me.total >= purchaseData.amount">
        <div class="info">
          <div class="img" v-if="purchaseData.img">
            <img :src="purchaseData.img" class="img-fluid rounded-start" />
          </div>
          <div class="body">
            <div class="name">{{ purchaseData.name }}</div>
            <div class="appName">{{ app.name }}</div>
            <div class="amount"><strong>￥ {{ purchaseData.amount.toLocaleString() }}</strong></div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <template v-if="purchaseResult === null && me.total < purchaseData.amount">
          <div v-show="me.hasCredit && purchaseModalOtherCharge === false">
            <!-- 残高不足・カード登録済み -->
            <form class="rakutenCreditContainer" @submit.prevent="creditChargeSubmit(notEnoughAmount)">
              <div class="purchaseModalChargeDetail">
                <div>
                  <div class="data add">
                    <div class="label">チャージ金額</div>
                    <div class="amount"><span>{{ notEnoughAmount.toLocaleString() }}</span> 円</div>
                  </div>
                  <div class="data current">
                    <div class="label">現在の残高</div>
                    <div class="amount"><span>{{ me.total.toLocaleString() }}</span> 円</div>
                  </div>
                  <div class="data after">
                    <div class="label">チャージ後の残高</div>
                    <div class="amount"><span>{{ (me.total + notEnoughAmount).toLocaleString() }}</span> 円</div>
                  </div>
                </div>
              </div>
              <div class="mt-3 text-start">
                <label class="form-label">使用するクレジットカード</label>
                <div class="cardNumber">
                  <span class="me-2 d-inline-block">**** **** **** {{ me.creditSuffix }}</span>
                  <span class="d-inline-block">({{ me.creditMonth }} / {{ me.creditYear }}) <span v-if="me.creditBrandIconClass !== null" class="brandIcon ms-1"><i :class="me.creditBrandIconClass"></i></span></span>
                </div>
              </div>
              <div class="mt-2 text-start" v-show="!me.creditCvvActive">
                <label class="form-label">セキュリティコード</label>
                <div>
                  <div class="rakuten-credit-input-wrapper cvv-input">
                    <div id="purchase-modal-cvv-mount"></div>
                  </div>
                </div>
              </div>
              <div class="mt-3 mb-3">
                <button type="submit" class="btn btn-dark btn-lg w-100 d-block">チャージする</button>
              </div>
            </form>
            <div v-if="purchaseCreditError">
              <div class="text-center text-danger mt-4 mb-2">
                クレジット決済に失敗しました
              </div>
              <div class="mb-4">
                <a class="btn btn-warning btn-lg" href="javascript:;" @click.prevent="credit(true)"><i class="fa-regular fa-credit-card"></i> クレジットカードを変更する</a>
              </div>
            </div>
            <div class="mt-2">
              <small><a class="link" href="javascript:;" @click.prevent="$refs.rakutenCreditModal.show()">カードを変更</a></small>
              ｜
              <small><a class="link" href="javascript:;" @click.prevent="purchaseModalOtherCharge = true">他の方法でチャージ</a></small>
            </div>
          </div>
          <!-- 残高不足・カード未登録 or 他の方法 -->
          <div v-show="!me.hasCredit || purchaseModalOtherCharge">
            <div class="text-center mb-2"><strong>チャージ方法を選択</strong></div>
            <div class="d-flex justify-content-center">
              <div class="paymentTypes">
                <a class="credit" href="javascript:;" @click.prevent="credit()">
                  <div class="logo">
                    <div class="icon">
                      <i class="creditIcon fa-regular fa-credit-card"></i>
                    </div>
                  </div>
                  <div class="title">クレジットカード</div>
                </a>
                <a class="googlePay" href="javascript:;" @click.prevent="googlePay(notEnoughAmount)">
                  <div class="logo">
                    <div class="icon">
                      <img src="/assets/google-pay-mark_800.svg" class="googlePayIcon" />
                    </div>
                  </div>
                  <div class="title">Google Pay</div>
                </a>
                <a class="amazonPay" href="javascript:;" @click.prevent="amazonPay(notEnoughAmount)">
                  <div class="logo">
                    <div class="icon">
                      <img src="/assets/amapay/Black-M.png" class="amazonPayIcon" />
                    </div>
                  </div>
                  <div class="title">Amazon Pay</div>
                </a>
                <a class="ganb" href="javascript:;" @click.prevent="$refs.ganbModal.show(notEnoughAmount)">
                  <div class="logo">
                    <div class="icon">
                      <i class="ganbIcon fa-sharp fa-regular fa-building-columns"></i>
                    </div>
                  </div>
                  <div class="title">銀行振込</div>
                </a>
                <a class="cvs" :href="'/p/account?cvs=1'">
                  <div class="logo">
                    <div class="icon">
                      <i class="cvsIcon fa-regular fa-shop"></i>
                    </div>
                  </div>
                  <div class="title">コンビニ払い</div>
                </a>
              </div>
            </div>
            <div v-show="me && me.total > 0" class="mt-3 mb-1">
              <div><span v-if="me.total > 0">ウォレット残高：<strong>{{ me.total.toLocaleString() }}</strong> 円</span></div>
              <div class="mt-2" v-if="me.total > 0 && notEnoughAmount > 0">不足金額は <i>{{ notEnoughAmount.toLocaleString() }}</i>円 です</div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- 残高あり -->
          <div><button @click.prevent="purchaseItemSubmit()" class="btn btn-dark btn-lg">アイテムを購入</button></div>

          <div v-if="me && me.total > 0" class="mb-2">
            <hr class="mt-3" />
            <div><span v-if="me.total > 0">ウォレット残高：<strong>{{ me.total.toLocaleString() }}</strong> 円</span></div>
            <div class="mt-2" v-if="leftAmount > 0"><i>残額は {{ leftAmount.toLocaleString() }} 円 になります。</i></div>
          </div>
        </template>
      </div>
    </Modal>
    <!--amazonPay-->
    <Modal v-model="amazonPayAmountModal" title="TapFunウォレットへのチャージ">
      <div class="mb-3">
        <form @submit.prevent="amazonPayChargeSubmit(amazonPayAmount)">
          <div class="mb-2 text-center">チャージ金額</div>
          <div class="mb-3 text-center">
             <span class="fw-bold display-6">{{ amazonPayAmount.toLocaleString() }} 円</span>
          </div>
          <div class="mt-2">
            <button type="submit" class="btn btn-dark d-block w-100"><i class="fa-brands fa-cc-amazon-pay"></i> AmazonPay でチャージ</button>
          </div>
        </form>
      </div>
    </Modal>
    <Modal v-model="amazonPayChargedModal" title="チャージが完了しました" :modalClass="amazonPayChargedModal">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            {{ amazonPayChargedAmount.toLocaleString() }}円のチャージが完了しました。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="amazonPayChargedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
    <!--googlePay-->
    <Modal v-model="googlePayAmountModal" title="TapFunウォレットへのチャージ">
      <div class="mb-3">
        <form @submit.prevent="googlePayChargeSubmit(googlePayAmount)">
          <div class="mb-2 text-center">チャージ金額</div>
          <div class="mb-3 text-center">
             <span class="fw-bold display-6">{{ googlePayAmount.toLocaleString() }} 円</span>
          </div>
          <div class="mt-3 text-center" ref="googlePayButton">
          </div>
        </form>
      </div>
    </Modal>
    <Modal v-model="googlePayChargedModal" title="チャージが完了しました" :modalClass="googlePayChargedModal">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            {{ googlePayChargedAmount.toLocaleString() }}円のチャージが完了しました。
          </div>
        </div>
        <div>
          <button type="button" class="btn btn-dark" @click.prevent="googlePayChargedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>

    <Modal v-model="purchaseNotPurchasableErrorModal" title="エラーが発生しました" @closing="purchaseModalClose" :modalClass="['purchaseNotPurchasableErrorModal']">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-danger">
            <template v-if="purchaseNotPurchasableErrorReason == 'duplicateTran'">
            すでに購入処理が完了しています。アイテムが反映されていない場合は、ゲーム運営会社までお問い合わせください。
            </template>
            <template v-else>
            先程のエラーが引き続き発生しております。誠に申し訳ございませんが、今しばらくお待ちください。お急ぎの場合は、ゲーム運営会社までお問い合わせくださいますようお願い申し上げます。
            </template>
          </div>
        </div>
        <div class="mb-3">
          <button type="button" class="btn btn-danger fw-bold" @click.prevent="purchaseNotPurchasableErrorModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
    <Modal v-model="purchaseCallbackErrorModal" title="エラーが発生しました" :modalClass="['purchaseCallbackErrorModal']">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-danger">
            決済は完了しましたが、ゲームサーバーとの通信エラーが発生しました。購入アイテムが反映されていない場合は、ゲーム運営会社までお問い合わせください。
          </div>
        </div>
        <div class="mb-3">
          <button type="button" class="btn btn-danger fw-bold" @click.prevent="purchaseCallbackErrorModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
    <Modal v-model="purchaseCallbackRejectedModal" title="購入は拒否されました" :modalClass="['purchaseCallbackRejectedModal']">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-danger">
            アイテムの購入は拒否されました。アイテム購入個数制限や期間限定などの理由が考えられます。ご不明点がある場合は、お手数ですがゲーム運営会社までお問い合わせください。
          </div>
        </div>
        <div class="mb-3">
          <button type="button" class="btn btn-danger fw-bold" @click.prevent="purchaseCallbackRejectedModal = false">閉じる</button>
        </div>
      </div>
    </Modal>
    <Modal v-model="loginReloadModal" :title="me ? 'ログインが完了しました' : 'ログアウトしました'" :modalClass="loginReloadModal" @closing="loginReload()">
      <div class="text-center">
        <div class="mb-3">
          <div class="alert alert-success">
            {{ me ? 'ログインが完了' : 'ログアウト' }}しました。ゲームを再起動します。
          </div>
        </div>
        <div class="mb-3">
          <button type="button" class="btn btn-danger fw-bold" @click.prevent="loginReloadModal = false">ゲームを再起動</button>
        </div>
      </div>
    </Modal>
    <Modal v-model="registerModal" title="TapFun アカウントを作成" @closing="purchaseModalClose" :modalClass="['registerModal', 'dark']">
      <p class="text-center">ゲームデータの保存、アイテムの購入には登録が必要です。</p>
      <form @submit.prevent="registerConfirm()">
        <div class="mt-4 mb-3 text-center">
          <button class="gsi-material-button" @click.prevent="registerModalGoogle()">
            <div class="gsi-material-button-state"></div>
            <div class="gsi-material-button-content-wrapper">
              <div class="gsi-material-button-icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span class="gsi-material-button-contents" style="font-weight: 700; color: #525252">Google アカウントで登録</span>
              <span style="display: none;">Sign in with Google</span>
            </div>
          </button>
        </div>
        <div class="mb-2">
          <div class="text-center mb-2">
            または
          </div>
          <label for="registerEmail" class="form-label">メールアドレス</label>
          <input type="email" class="form-control" :class="{'is-invalid': registerError}" id="registerEmail" ref="registerEmail" v-model="registerEmail" placeholder="address@example.com" required />
        </div>
        <div class="mb-3">
          <label for="registerPassword" class="form-label">パスワード</label>
          <input :type="registerPasswordType" class="form-control" :class="{'is-invalid': registerError}" id="registerPassword" v-model="registerPassword" placeholder="8文字以上を入力" required minlength="8" autocomplete="new-password" @focus="passwordFocus()" @blur="passwordBlur()" />
          <div class="invalid-feedback">
            アカウントが見つかりませんでした
          </div>
        </div>
        <div class="alert alert-danger text-center" v-if="alreadyRegistered">
          そのメールアドレスはすでに登録されています
        </div>
        <div class="mb-3">
          <button type="submit" class="btn btn-danger fw-bold w-100">認証コードを送信</button>
        </div>
        <div class="">
          アカウントをすでにお持ちの場合は、<a href="javascript:;" @click="registerModal = false; $refs.layout.showLoginModal()" class="text-decoration-underline">こちら</a>
        </div>
      </form>
    </Modal>
    <Modal v-model="registerCompleteCodeModal" title="認証コードを入力してください" :modalClass="['registerCompleteCodeModal', 'dark']">
      <div class="text-center mt-2 mb-4">
        「{{ registerEmail }}」へ認証コードを送信しました。
      </div>
      <div class="mb-3 d-flex justify-content-center codes" ref="registerCompleteCodeParent">
        <HOtpInput
          :length="4" 
          type="tel" 
          @on-finish="registerCompleteCodeFinish"
          @on-change="registerCompleteCodeChange" 
          :outlined="false"
          ref="registerCompleteCode"
          :only-number="true"
        />
      </div>
      <div class="mb-3 text-center" v-if="registerCompleteCodeMissMatch">
        <div class="alert alert-danger">
          入力された認証コードが一致しません
        </div>
      </div>
      <div class="mb-4 d-flex justify-content-center" v-if="registerCompleteCode.length == 4">
        <button type="button" class="btn btn-danger fw-bold w-75" @click.prevent="registerSubmit()">次へ</button>
      </div>
      <div class="mb-4 d-flex justify-content-center" v-else>
        <button type="button" class="btn btn-danger fw-bold w-75" disabled @click.prevent="registerCompleteCodeSubmit()">コードを入力して下さい</button>
      </div>
      <div class="text-center">
        <a href="javascript:;" class="text-decoration-underline" @click.prevent="registerFix()">メールアドレスを修正</a>
      </div>
    </Modal>
    <Modal v-model="registerCompleteModal" title="登録が完了しました" :modalClass="['registerCompleteModal', 'dark']">
      <div class="text-center mt-2">
        <button type="button" class="btn btn-light fw-bold" @click.prevent="registerCompletePurchaseBack()">アイテム購入へ戻る</button>
      </div>
    </Modal>
    <Modal v-model="registerGoogleCompleteModal" title="登録が完了しました" :modalClass="['registerGoogleCompleteModal', 'dark']">
      <div class="text-center mt-2">
        <button type="button" class="btn btn-light fw-bold" @click.prevent="registerGoogleCompleteModal = false">閉じる</button>
      </div>
    </Modal>
    <Modal v-model="openUrlModal" title="この先は外部サイトです" :modalClass="['openUrlModal']">
      <div class="mb-3 mt-2">
        <a :href="openUrlUrl" target="_blank" @click.prevent="openUrlOpen()" class="url">
          {{ openUrlUrl }}
        </a>
      </div>
      <div class="mb-2">
        <button type="button" class="btn btn-outline-dark fw-bold" @click.prevent="openUrlOpen()">開く</button>
      </div>
    </Modal>
    <Modal v-model="inputTextSingleLineModal" :title="inputTextSingleLineData.title ?? '入力して下さい'" @closing="inputTextSingleLineModalCancel()" :modalClass="['inputTextSingleLineModal']" :wrapperClass="inputTextSingleLineModalWrapperClass">
      <form @submit.prevent="inputTextSingleLineModalSubmit()">
        <div>
          <input type="text" class="form-control" ref="inputTextSingleLineModalInput" v-model="inputTextSingleLineModalText" :placeholder="inputTextSingleLineData.placeholder ?? '入力して下さい'" :maxlength="inputTextSingleLineModalTextMaxlength" required />
        </div>
        <div class="info">
          <div class="count">入力 {{ inputTextSingleLineModalTextCount }} 文字 / 最大 {{ inputTextSingleLineModalTextMaxlength }} 文字</div>
          <div class="enter"><span v-if="!isSP()">Enter で送信</span></div>
        </div>
        <div class="d-flex justify-content">
          <button type="submit" class="btn btn-dark fw-bold w-100 me-1">{{ inputTextSingleLineData.submit }}</button>
          <button type="button" class="btn btn-outline-dark w-100 ms-1" @click.prevent="inputTextSingleLineModalCancel()">{{ inputTextSingleLineData.cancel }}</button>
        </div>
      </form>
    </Modal>
    <Modal v-model="inputTextMultiLineModal" :title="inputTextMultiLineData.title" @closing="inputTextMultiLineModalCancel()" :modalClass="['inputTextMultiLineModal']" :wrapperClass="inputTextMultiLineModalWrapperClass">
      <form @submit.prevent="inputTextMultiLineModalSubmit()">
        <div>
          <textarea class="form-control inputTextMultiLine" :class="{'is-invalid': inputTextMultiLineModalTextCount > inputTextMultiLineModalTextMaxlength }" ref="inputTextMultiLineModalInput" v-model="inputTextMultiLineModalText" :placeholder="inputTextMultiLineData.placeholder" required  @keydown.enter="inputTextMultiLineModalTextEnter"/>
        </div>
        <div class="info">
          <div class="count" :class="{'over': inputTextMultiLineModalTextCount > inputTextMultiLineModalTextMaxlength }">入力 {{ inputTextMultiLineModalTextCount }} 文字 / 最大 {{ inputTextMultiLineModalTextMaxlength }} 文字</div>
          <div class="enter"><span v-if="!isSP()">Ctrl (Cmd) + Enter で送信</span></div>
        </div>
        <div class="d-flex justify-content">
          <button type="submit" class="btn btn-dark fw-bold w-100 me-1" :class="{'over': inputTextMultiLineModalTextCount > inputTextMultiLineModalTextMaxlength }">{{ inputTextMultiLineData.submit }}</button>
          <button type="button" class="btn btn-outline-dark w-100 ms-1" @click.prevent="inputTextMultiLineModalCancel()">{{ inputTextMultiLineData.cancel }}</button>
        </div>
      </form>
    </Modal>
    <Modal v-model="copyTextModal" :title="copyTextData.title ?? 'コピーして下さい'">
      <div class="mb-3">
        <input type="text" class="form-control" ref="copyTextValue" :value="copyTextData.text" disabled />
      </div>
      <div class="d-flex justify-content">
        <button type="button" class="btn btn-outline-dark w-100 ms-1" @click.prevent="copyTextToClipboard()">クリップボードにコピー</button>
      </div>
    </Modal>
    <RakutenCreditModal :me="me" ref="rakutenCreditModal" :showLoadingOverlay="showLoadingOverlay" :hideLoadingOverlay="hideLoadingOverlay" :session="session" :closeModal="rakutenCreditModalClose" />
    <GanbModal :me="me" ref="ganbModal" :showLoadingOverlay="showLoadingOverlay" :hideLoadingOverlay="hideLoadingOverlay" />
  </LayoutHeader>
</template>

<script>
import baseMixin from './base';
import { HOtpInput } from "@healerlab/vue3-simple-otp-input";
import RakutenCreditModal from './Components/RakutenCreditModal.vue';
import GanbModal from './Components/GanbModal.vue';
import { toast } from 'vue3-toastify';

export default {
  mixins: [
    baseMixin,
  ],
  components: {
    HOtpInput,
    RakutenCreditModal,
    GanbModal,
  },
  data () {
    return {
      app: null,
      onnine: null,
      ws: null,
      launchParamsSession: 'previous',

      purchaseItemStopper: false,
      purchaseModal: false,
      purchaseData: null,
      purchaseResult: null,
      purchaseCreditError: null,
      purchaseModalOtherCharge: false,

      purchaseNotPurchasableErrorModal: false,
      purchaseNotPurchasableErrorReason: '',

      purchaseCallbackErrorModal: false,

      purchaseCallbackRejectedModal: false,
      purchaseCallbackRejectedModalNotEnoughAmount: '',

      registerModal: this.$route.query.register ? true : false,
      alreadyRegistered: false,
      registerEmail: this.$route.query.register ??  '',
      registerPassword: this.$route.query.register ?? '',
      registerPasswordType: 'password',
      registerCompleteCodeModal: this.$route.query.registerCompleteCodeModal == '1' ?? false,
      registerCompleteCode: '',
      registerCompleteCodeMissMatch: false,
      registerCompleteModal: this.$route.query.registerCompleteModal == '1' ?? false,
      registerGoogleCompleteModal: false,

      openUrlModal: false,
      openUrlUrl: 'https://example.com/',

      inputTextSingleLineData: {},
      inputTextSingleLineModal: false,
      inputTextSingleLineModalText: '',
      inputTextSingleLineModalTextDefaultMaxlength: this.$route.query.inputTextSingleLineModalTextDefaultMaxlength ?? 128,
      inputTextSingleLineClosed: true,

      inputTextMultiLineChunkTexts: [],
      inputTextMultiLineData: {},
      inputTextMultiLineModal: false,
      inputTextMultiLineModalText: '',
      inputTextMultiLineModalTextDefaultMaxlength: this.$route.query.inputTextMultiLineModalTextDefaultMaxlength ?? 128,
      inputTextMultieLineClosed: true,

      copyTextData: {'text': ''},
      copyTextModal: false,

      loginReloadModal: this.$route.query.loginReloadModal ? true : false,

      creditAmountModal: false,
      creditAmount: '',
      creditChargedModal: false,
      creditChargedAmount: null,

      amazonPayAmountModal: false,
      amazonPayAmount: '',
      amazonPayChargedModal: false,
      amazonPayChargedAmount: null,

      googlePayAmountModal: false,
      googlePayAmount: '',
      googlePayChargedModal: false,
      googlePayChargedAmount: null,

      resized: false,
      firstframearrived: false,
      onnineStatus: '',
      onnineError: '',
      onnineNotFound: this.$route.query.onnineNotFound ? true : false,
      gesturecompleted: false,
      gesturecompletedCount: 0,
      idledisconnect: false,
      noAvailableSlot: false,
      appMaintenance: false,
      stopped: false,

      showDebugLog: this.$route.query.debug == '1' ? true : false,
      rightDebugLog: false,
      debugLogs: [
        'このログ表示はダブルクリックで左右移動できます',
      ],
      debugSessionIntervalId: null,
    }
  },
  computed: {
    notEnoughAmount() {
      return this.me.total < this.purchaseData.amount ? this.purchaseData.amount - this.me.total : 0;
    },
    leftAmount() {
      return this.me.total - this.purchaseData.amount;
    },
    imageUrl() {
      return this.isSP() ? this.app.loadingSP : this.app.loadingPC;
    },
    purchaseModalTitle() {
      return this.me.total < this.purchaseData.amount ? '不足分をチャージします' : '購入内容の確認';
    },
    inputTextSingleLineModalTextCount() {
      return this.inputTextSingleLineModalText.length;
    },
    inputTextSingleLineModalTextMaxlength() {
      return this.inputTextSingleLineData.maxlength ?? this.inputTextSingleLineModalTextDefaultMaxlength;
    },
    inputTextSingleLineModalWrapperClass() {
      return this.inputTextMultiLineData.position == 'bottom' ? 'bottom' : '';
    },
    inputTextMultiLineModalTextCount() {
      return this.inputTextMultiLineModalText.length;
    },
    inputTextMultiLineModalTextMaxlength() {
      return this.inputTextMultiLineData.maxlength ?? this.inputTextMultiLineModalTextDefaultMaxlength;
    },
    inputTextMultiLineModalWrapperClass() {
      return this.inputTextMultiLineData.position == 'bottom' ? 'bottom' : '';
    },
  },
  methods: {
    _mounted() {
    },
    _unmounted() {
      console.log('_unmounted');
      if (this.ws) {
        this.ws.close();
      }
      this.stop();
      return false;
    },
    _firstMeSeted() {
      this.setUp();
    },
    _meSeted(me, session) {
      if (session && session.flash == 'registerGoogle') {
        this.registerGoogleCompleteModal = true;
      }
      if (session && session.flash && session.flash.type == 'amazonPayCharged') {
        this.amazonPayChargedModal = true;
        this.amazonPayChargedAmount = parseInt(session.flash.amount);
      }
    },
    _appsSeted() {
    },
    async setUp() {
      this.app = (await this.axios({
        url: '/apps/' + this.$route.params.app,
        method: 'get',
      })).data;
      this.setTitle(this.app.title);
      this.session();
      if (this.$route.query.purchase == '1') {
        this.registerEmail = 'a+registertest@tapfun.co.jp';
        this.registerPassword = 'testtest';
        this.dummyPurchase();
      }
      this.launch();
      if (process.env.DEBUG === 'yes') {
        this.ws = new WebSocket("/ws");
        this.ws.onmessage = (event) => {
          console.log("WebSocketメッセージ受信", event.data);
          const data = JSON.parse(event.data);
          if (data.type == 'deploy') {
            this.stop();
            toast('デプロイが行われたため、ゲームを終了しました。', {
              position: 'top-center',
              type: 'info',
              transition: 'slide',
              autoClose: false,
            });
          }
        };
      }
    },
    async _resize() {
      if (this.$refs.playContainer && this.firstframearrived && !this.resized) {
        this.hundred();
      }
    },
    async launch() {
      if (this.app.maintenance && !this.$route.query.forceNoMaintenance) {
        this.appMaintenance = true;
        return;
      }
      if (this.logoutDate) {
        // this.$refs.layout.showLoginModal();
      }
      if (this.onnine) {
        return this.onnine.play();
      }
      this.initial();
    },
    async initial() {
      const elm = document.querySelector('#gamePlayContainer');
      var config = {
        game: this.app.game,
        server: this.config.Ubitus.server,
        width: elm.getBoundingClientRect().width,
        height: elm.getBoundingClientRect().height,
        target: '#' + elm.id,
        auth: {
          token: this.app.token,
          provider_id: this.config.Ubitus.providerId,
          channel: this.config.Ubitus.channel,
        },
        launchParams: {
          "session": this.launchParamsSession,
          // "session": "new",
          "setting": {
            "noteardown": true,
          },
          "idleTimeout": 600,
          "kickoutTimeout": 600,
        },
        loadingComponent: {
          imageUrl: this.imageUrl,
          disableMessage: true,
        },
      };
      this.launchParamsSession = 'previous';
      console.info('Ubitus config', config);
      console.info('Ubitus launchParams', config.launchParams);
      if (typeof OnNine === 'undefined') {
        this.onnineNotFound = true;
        return;
      }
      OnNine.initializeAsync(config).then(onnine => {
        this.onnine = onnine;
        window.onnine = onnine;
        // this.onnine.toggleFPSAddon(true);
        // do something
        onnine.addEventListener("customEvent", msg => {
          const data = [...new URLSearchParams(msg).entries()].reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});
          console.info('customEvent', data);
          this.addDebugLog('[customEvent] ' + JSON.stringify(data));

          const req = data.req ?? data.event;

          if (req === 'purchaseItem') {
              this.purchaseItem(data);
          }
          if (req === 'openUrl') {
              this.openUrl(data);
          }
          if (req === 'openImeDialog') {
              this.openImeDialog(data.default || '');
          }
          if (req === 'inputTextSingleLine') {
            this.inputTextSingleLine(data);
          }
          if (req === 'inputTextMultiLine') {
            this.inputTextMultiLine(data);
          }
          if (req === 'inputTextMultiLineChunkText') {
            this.inputTextMultiLineChunkText(data);
          }
          if (req === 'copyText') {
            this.copyText(data);
          }
          if (req === 'getPlayerEnvironment') {
            this.getPlayerEnvironment(data);
          }
          if (req === 'reboot') {
              this.reboot(data);
          }
          if (req === 'consoleLog') {
              this.consoleLog(data);
          }
        });
        onnine.addEventListener("status", msg => {
          this.onnineStatus = msg;
          if (msg === 'startstreaming') {
            this.noAvailableSlot = false;
          }
          if (msg === 'firstframearrived' && !this.firstframearrived) {
            this.hundred();
            this.firstframearrived = true;
            this.onnine.openImeDialog('');
          }
          if (msg === 'gesturecompleted') {
            this.gesturecompleted = true;
            this.gesturecompletedCount++;
            if (this.gesturecompletedCount == 1) {
              console.log('gamePlay');
              this.axios({
                url: '/gamePlay',
                method: 'post',
              });


              // PLAYコンバージョントラッキング
              gtag('event', 'conversion', {'send_to': 'AW-16815137145/mcN0CN-9_fcZEPnCitI-'});
              twq('event', 'tw-oyzde-oyzdg', { });
              ytag({
                "type": "yss_conversion",
                "config": {
                  "yahoo_conversion_id": "1001356725",
                  "yahoo_conversion_label": "Nsn6COzWwJUaEJuOoYMr",
                  "yahoo_conversion_value": "100"
                }
              });

              // ゲームプレイ開始 Y!ディスプレイ広告
              ytag({
                "type":"yjad_conversion",
                "config":{
                  "yahoo_ydn_conv_io": "jNHGJFn2HIlwR_zLO10IXw..",
                  "yahoo_ydn_conv_label": "5GAM5Q8P58FBWY41SG1212283",
                  "yahoo_ydn_conv_transaction_id": "",
                  "yahoo_ydn_conv_value": "300"
                }
              });
            }
            this.sendWmCopyData({
              'from': 'ubitusStatus',
              'result': 'gesturecompleted',
              'count': this.gesturecompletedCount,
            });
          }
          console.info(`[${this.app.game}][status]`, msg);
          this.addDebugLog(`[status] ${msg}`);
        });
        onnine.addEventListener("error", msg => {
          this.allModalClose();

          console.info(`[${this.app.game}][error]`, msg);
          const json = JSON.stringify(msg);
          this.addDebugLog(`[error] ${json}`);
          this.onnineError = JSON.stringify(msg);
          this.noAvailableSlot = msg.code == '64000010'; // no avaliable slot
          if (msg.code == '82600962') { // idledisconnect
            this.idledisconnect = true;
          } else
          if (msg.code == '10101048') {
            alert('別の環境で同一ゲームが起動したため終了しました。');
          } else if (
               msg.code == '64000009'
            || msg.code == '64000010' // no avaliable slot
            || msg.code == '64000040'
            || msg.code == '68000041' // teardown
          ) {
            this.stopLaunch();
          } else {
            this.stopped = true;
            // alert(JSON.stringify(msg));
            console.error('exception error ubitus', msg);
          }
        });
        this.onnine.play();
      });
    },
    async stopLaunch() {
      this.onnine.stopAsync().then(() => {
        this.allModalClose();
        console.log('stopAsync succeseed')
        this.onnine = null;
        this.launch();
      });
    },
    async play() {
      this.launch();
    },
    async stop() {
      console.log('stop');
      if (this.onnine) {
        this.onnine.stopAsync().then(() => {
          console.log('stopAsync')
          this.onnine = null;
        });
      }
    },
    async sendWm() {
      this.sendWmCopyData('data=' + prompt('Input sendWmCopyData'));
    },
    dummyPurchase() {
      this.purchaseItem({
        req: 'purchaseItem',
        appId: this.app.id,
        tran: 'abcdef123456' + (new Date()).getTime(),
        code: 'gem1000',
        item: 'itemGem1000',
        amount: 300,
        name: '300ジェム',
        img: 'https://imagedelivery.net/qa6Tzad6bwKOH_OWv1jzvA/f3f6096a-0e3c-4942-2919-882736463000/public',
        note: 'notehoge',
        sig: 'sigfuga',
      });
    },
    async purchaseItem(data) {
      this.purchaseData = { ...data, ...{
        amount: parseInt(data.amount),
      }};
      const requiredParams = ['tran', 'code', 'amount', 'name'];
      for (const param of requiredParams) {
        if (!this.purchaseData[param]) {
          this.sendWmCopyData({
            'from':'purchaseItem',
            'result': 'parameterError',
            'reason': 'required param not found "' + param + '"',
          });
          return;
        }
      }
      const sendData = {
        'from':'purchaseItem',
        'tran': this.purchaseData.tran,
        'code': this.purchaseData.code,
        'result': 'received',
      };
      this.sendWmCopyData(sendData);

      this.exitFullscreen();
      if (this.me === false) {
        this.registerModal = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.registerEmail.focus();
          }, 300);
        });
        return;
      }
      const purchasableResult = await this.purchasableCheck();
      if (purchasableResult.unfinishedCheck === false) {
        this.purchaseNotPurchasableErrorModal = true;
        this.purchaseNotPurchasableErrorReason = 'unfinishedClallbackPrucahseRemaining';
        this.sendWmCopyData({
          'from':'purchaseItem',
          'tran': this.purchaseData.tran,
          'code': this.purchaseData.code,
          'result': 'incompleteCallback',
          'reason': 'unfinishedClallbackPrucahseRemaining',
        });
        return;
      }
      if (purchasableResult.alreadyTranCheck === false) {
        this.purchaseNotPurchasableErrorModal = true;
        this.purchaseNotPurchasableErrorReason = 'duplicateTran';
        this.sendWmCopyData({
          'from':'purchaseItem',
          'tran': this.purchaseData.tran,
          'code': this.purchaseData.code,
          'result': 'incompleteCallback',
          'reason': 'duplicateTran',
        });
        return;
      }
      this.purchaseModalOpen();
    },
    async purchasableCheck() {
      if (this.$route.query.purchasableCheck == '0') {
        return {
          unfinishedCheck: true,
          alreadyTranCheck: true,
        };
      }
      try {
        const res = await this.axios({
          url: '/purchasable',
          method: 'get',
          params: {
            appId: this.app.id,
            code: this.purchaseData.code,
            tran: this.purchaseData.tran,
          },
        });
        return res.data;
      } catch (e) {
        console.error(e);
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
        return null;
      }
    },
    purchaseModalOpen() {
      this.purchaseModal = true;
      this.purchaseResult = null;
      if (!this.me.creditCvvActive) {
        this.$nextTick(() => {
          const inputElementStyles = this.$refs.rakutenCreditModal.getInputElementStyles();
          try {
            if (payvault && payvault.destroy) payvault.destroy();
          } catch (e) {
          }
          payvault.setup({
            cvv: {
              mount: '#purchase-modal-cvv-mount',
              styles: inputElementStyles,
              placeholder: 'CVV',
              height: '46px',
            },
          });
        });
      }
    },
    purchaseItemSubmit() {
      if (this.purchaseItemStopper) return;
      this.purchaseItemStopper = true;
      setTimeout(() => {
        this.purchaseItemStopper = false;
      }, 2000);
      this.purchaseResult = null;
      this.purchaseCreditError = false;
      this.loadingOverlay = true;
      const sendData = {
        'from':'purchaseItem',
        'tran': this.purchaseData.tran,
        'code': this.purchaseData.code,
        'result': 'purchase',
      };
      this.sendWmCopyData(sendData);

      const data = {
        appId: this.app.id,
        tran: this.purchaseData.tran,
        name: this.purchaseData.name,
        amount: this.purchaseData.amount,
        code: this.purchaseData.code,
        item: this.purchaseData.item,
        img: this.purchaseData.img,
        note: this.purchaseData.note,
        sig: this.purchaseData.sig,
      };

      this.axios({
        url: '/purchase',
        method: 'post',
        data: data,
      }).then(res => {
        this.purchaseResult = res.data;
        if (res.data === false) {
          alert(res.data);
          this.loadingOverlay = false;
          return;
        }
        if (res.data.error) {
          this.loadingOverlay = false;
          switch (res.data.error) {
            case 'notPurchasableError':
              this.purchaseNotPurchasableErrorModal = true;
              this.purchaseNotPurchasableErrorReason = res.data.reason;
              this.purchaseResult = null;
              this.sendWmCopyData({
                'from':'purchaseItem',
                'tran': this.purchaseData.tran,
                'code': this.purchaseData.code,
                'result': 'incompleteCallback',
                'reason': res.data.reason,
              });
              this.purchaseModal = false;
              break;
            case 'callbackError':
              this.purchaseCallbackErrorModal = true;
              this.sendWmCopyData({
                'from':'purchaseItem',
                'tran': this.purchaseData.tran,
                'code': this.purchaseData.code,
                'result': 'incompleteCallback',
                'reason': 'unknown',
              });
              this.purchaseModal = false;
              break;
            case 'callbackRejected':
              this.purchaseCallbackRejectedModal = true;
              this.purchaseCallbackRejectedModalNotEnoughAmount = parseInt(res.data.notEnoughAmount);
              this.sendWmCopyData({
                'from':'purchaseItem',
                'tran': this.purchaseData.tran,
                'code': this.purchaseData.code,
                'result': 'incompleteCallback',
                'reason': 'rejected',
              });
              this.purchaseModal = false;
              break;
            default:
              alert(res.data.message);
              this.purchaseModal = false;
              break;
          }
          return;
        }
        gtag('event', 'conversion', {
          'send_to': 'AW-16815137145/HJNYCPzm_fcZEPnCitI-',
          'transaction_id': ''
        });
        // // 課金
        // ytag({
        //   "type":"yjad_conversion",
        //   "config":{
        //     "yahoo_ydn_conv_io": "jNHGJFn2HIlwR_zLO10IXw..",
        //     "yahoo_ydn_conv_label": "D98SVK8D6NZ5V7ZVM91213897",
        //     "yahoo_ydn_conv_transaction_id": "",
        //     "yahoo_ydn_conv_value": "10000"
        //   }
        // });
        twq('event', 'tw-oyzde-oyzdf', {
          value: parseInt(this.purchaseData.amount),
          currency: 'JPY',
        });
        this.sendWmCopyData({
          'from':'purchaseItem',
          'tran': this.purchaseData.tran,
          'code': this.purchaseData.code,
          'result': 'purchaseSuccess',
        });
        this.loadingOverlay = false;
        this.purchaseModal = false;
        this.setMe(res.data.me);
      }).catch(err => {
        console.log(err);
        this.loadingOverlay = false;
        alert('不明なエラーが発生しました。しばらく待ってから再度お試しください。');
      });
    },
    async consoleLog(data) {
      let logData;
      try {
        const json = JSON.parse(data);
        logData = json;
      } catch (e) {
        logData = data;
      }
      console.log('consoleLog', logData);
    },
    purchaseModalClose() {
      this.purchaseModalOtherCharge = false;
      if (!this.purchaseResult) {
        this.sendWmCopyData({
          'from':'purchaseItem',
          'tran': this.purchaseData.tran,
          'code': this.purchaseData.code,
          'result': 'purchaseCancel',
        });
      }
    },
    openUrl(data) {
      console.info('openUrl', data);
      this.openUrlUrl = data.url;
      this.openUrlModal = true;
    },
    openUrlOpen() {
      this.openUrlModal = false;
      window.open(this.openUrlUrl, '_blank');
    },
    sendWmCopyData(data) {
      if (!this.onnine) return;
      const sendData = typeof data == 'object' ? new URLSearchParams(data).toString() : data;
      console.info('sendWmCopyData', data, sendData);
      this.addDebugLog('[sendWmCopyData] ' + sendData);
      this.onnine.sendWmCopyData(sendData);
    },
    addDebugLog(data) {
      console.debug('[DEBUG LOG]', data);
      if (typeof data === 'object') {
        data = JSON.stringify(data);
      }
      this.debugLogs.push(data);
      this.$nextTick(() => {
        if (this.$refs.debugLogLines) {
          this.$refs.debugLogLines.scrollTop = this.$refs.debugLogLines.scrollHeight;
        }
      });
    },
    hundred() {
      this.resized = true;
      Object.assign(this.$refs.playContainer.style, {
        'width': '100%',
        'height': '100%',
      });
      Object.assign(this.$refs.playContainer.querySelector('iframe').style, {
        'width': '100%',
        'height': '100%',
      });
    },
    openImeDialog(defaultText = '') {
      this.onnine.openImeDialog(defaultText);
    },
    windowFocus() {
      // console.log('windowFocus');
      this.session(false, false, () => {
        this.loginReloadModal = true;
      });
    },
    loginReload() {
      location.reload();
    },
    fullscreen() {
      console.log('fullscreen');
      this.onnine.requestFullscreen();
    },
    restart(reconfirm = true) {
      if (reconfirm && !confirm('ゲームを再起動しますか？')) return;
      return this.reboot();
    },
    getPlayerEnvironment() {
      const elm = document.querySelector('#gamePlayContainer');
      this.sendWmCopyData({
        'from':'getPlayerEnvironment',
        'isSP': this.isSP() ? '1' : '0',
      });
    },
    reboot() {
      console.log('reboot');
      this.firstframearrived = false;
      this.gesturecompleted = false;
      this.idledisconnect = false;
      this.stopped = false;
      this.onnine.stopAsync().then(() => {
        console.log('stopAsync succeseed')
        this.launchParamsSession = 'new';
        this.onnine = null;
        this.launch();
      });
    },
    registerConfirm() {
      this.registerCompleteCodeMissMatch = false;
      this.loadingOverlay = true;
      this.passwordBlur();
      this.registerCompleteCode = '';
      this.axios({
        method: 'post',
        url: '/register/confirm',
        data: {
          email: this.registerEmail,
          password: this.registerPassword,
        },
      }).then((r) => {
        if (r.data.error == 'alreadyRegistered') {
          this.alreadyRegistered = true;
          this.loadingOverlay = false;
          return;
        }
        this.loadingOverlay = false;
        this.registerModal = false;
        this.registerCompleteCodeModal = true;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.registerCompleteCodeParent.querySelector('input:first-child').focus();
          }, 300);
        });
      }).catch((e) => {
        console.error(e);
        this.loadingOverlay = false;
        alert('通信エラー');
      });
    },
    registerCompleteCodeChange(code) {
      this.registerCompleteCode = code;
    },
    registerCompleteCodeFinish(code) {
      this.registerCompleteCode = code;
      this.registerSubmit();
    },
    registerFix() {
      this.registerModal = true;
      this.registerCompleteCodeModal = false;
    },
    registerSubmit() {
      const data = {};
      data.email = this.registerEmail;
      data.password = this.registerPassword;
      data.code = this.registerCompleteCode;
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/register',
        data: data,
      }).then((r) => {
        this.loadingOverlay = false;
        if (r.data.error == 'codeMissMatch') {
          this.registerCompleteCodeMissMatch = true;
          this.$refs.registerCompleteCode.clear();
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.registerCompleteCodeParent.querySelector('input:first-child').focus();
            }, 300);
          });
          return;
        }
        if (r.data.error == 'alreadyRegistered') {
          alert('すでに登録されています。');
          return;
        }
        this.setMe(r.data.me);
        this.registerCompleteCodeModal = false;
        this.registerCompleteModal = true;
      }).catch((e) => {
        console.error(e);
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
        this.loadingOverlay = false;
      });
    },
    registerCompletePurchaseBack() {
      this.registerCompleteModal = false;
      this.purchaseModalOpen();
    },
    inputTextSingleLine(param) {
      const dataDefault = {
        'label': '',
        'text': '',
        'position': '',
        'title': '入力して下さい',
        'submit': '入力完了',
        'cancel': 'キャンセル',
        'placeholder': '入力して下さい',
        'maxlength': this.inputTextSingleLineModalTextDefaultMaxlength,
      };
      const data = { ...dataDefault, ...param };
      if (data.maxlength > 128) {
        return false;
      }
      console.log(data);
      this.exitFullscreen();
      this.inputTextSingleLineClosed = false;
      this.inputTextSingleLineData = data;
      this.inputTextSingleLineModal = true;
      this.inputTextSingleLineModalText = data.text;
      this.inputTextSingleLineModalTitle = data.title;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.inputTextSingleLineModalInput.focus();
        }, 300);
      });
    },
    inputTextSingleLineModalSubmit() {
      const text = this.inputTextSingleLineModalText.slice(0, 128);
      this.sendWmCopyData({
        'from':'inputTextSingleLine',
        'result': 'submit',
        'label': this.inputTextSingleLineData.label,
        'text': text,
      });
      this.inputTextSingleLineClosed = true;
      this.inputTextSingleLineModal = false;
    },
    inputTextSingleLineModalCancel() {
      if (this.inputTextSingleLineClosed) return;
      this.sendWmCopyData({
        'from':'inputTextSingleLine',
        'result': 'cancel',
        'label': this.inputTextSingleLineData.label ?? '',
      });
      this.inputTextSingleLineClosed = true;
      this.inputTextSingleLineModal = false;
    },
    inputTextMultiLineChunkText(data) {
      const text = data.text ?? '';
      const seq = parseInt(data.seq);
      if (!text || !seq || seq > 100) return;
      // seq text end
      this.inputTextMultiLineChunkTexts[data.seq] = data.text;
    },
    inputTextMultiLine(param) {
      const dataDefault = {
        'label': '',
        'text': '',
        'end': '',
        'position': '',
        'title': '入力して下さい',
        'submit': '入力完了',
        'cancel': 'キャンセル',
        'placeholder': '入力して下さい',
        'maxlength': this.inputTextMultiLineModalTextDefaultMaxlength,
      };
      const data = { ...dataDefault, ...param };
      if (data.maxlength > 10000) {
        return false;
      }
      console.log(data);
      const end = parseInt(data.end);
      this.exitFullscreen();
      this.inputTextMultiLineData = data;
      this.inputTextMultiLineClosed = false;
      this.inputTextMultiLineModal = true;
      let text = '';
      if (end > 0) {
        for (let i = 1; i <= end; i++) {
          if (this.inputTextMultiLineChunkTexts[i]) {
            text += this.inputTextMultiLineChunkTexts[i];
          }
        }
        this.inputTextMultiLineChunks = [];
      } else {
        text = data.text;
      }
      this.inputTextMultiLineModalText = text;
      this.inputTextMultiLineModalTitle = data.title ?? null;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.inputTextMultiLineModalInput.focus();
        }, 300);
      });
    },
    inputTextMultiLineModalSubmit() {
      const text = this.inputTextMultiLineModalText;
      const textLength = text.length;
      if (textLength > this.inputTextMultiLineModalTextMaxlength) {
        toast('最大文字数の' + this.inputTextMultiLineModalTextMaxlength + '文字を超えています。', {
          type: 'error',
          transition: 'slide',
          hideProgressBar: true,
          position: 'top-center',
          autoClose: 2000,
        });
        return false;
      }
      const chunkLength = 128;
      const sequence = Math.ceil(textLength / chunkLength);
      for (let i = 0; i < sequence; i++) {
        const start = i * chunkLength;
        const end = start + chunkLength;
        const part = text.slice(start, end);
        this.sendWmCopyData({
          'from':'inputTextMultiLine',
          'result': 'submit',
          'label': this.inputTextMultiLineData.label ?? '',
          'text': part,
          'seq': i + 1,
          'end': sequence,
        });
      }
      this.inputTextMultiLineClosed = true;
      this.inputTextMultiLineModal = false;
    },
    inputTextMultiLineModalCancel() {
      if (this.inputTextMultiLineClosed) return;
      this.sendWmCopyData({
        'from':'inputTextMultiLine',
        'result': 'cancel',
        'label': this.inputTextMultiLineData.label ?? '',
      });
      this.inputTextMultiLineClosed = true;
      this.inputTextMultiLineModal = false;
    },
    inputTextMultiLineModalTextEnter(e) {
      if (e.ctrlKey || e.metaKey) {
        this.inputTextMultiLineModalSubmit();
      }
    },
    copyText(data) {
      this.copyTextData = data;
      this.copyTextModal = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.copyTextValue.select();
        }, 300);
      });
    },
    copyTextToClipboard() {
      navigator.clipboard.writeText(this.copyTextData.text).then(() => {
        alert('コピーしました');
      }, () => {
        alert('コピーに失敗しました');
      });
    },
    exitFullscreen() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      }
    },
    passwordFocus() {
      this.registerPasswordType = 'text';
    },
    passwordBlur() {
      this.registerPasswordType = 'password';
    },
    allModalClose() {
      this.purchaseModal = false;
      this.registerModal = false;
      this.registerCompleteModal = false;
      this.registerCompleteCodeModal = false;
      this.openUrlModal = false;
      this.inputTextSingleLineModal = false;
      this.inputTextMultiLineModal = false;
      if (this.$refs.rakutenCreditModal && typeof this.$refs.rakutenCreditModal.hide === 'function') {
        this.$refs.rakutenCreditModal.hide();
      }
    },
    credit(forceEdit) {
      if (!this.me.hasCredit || forceEdit) {
        this.$refs.rakutenCreditModal.show();
      } else {
        this.purchaseModalOtherCharge = false;
      }
    },
    amazonPay(amount) {
      this.amazonPayAmount = amount;
      this.amazonPayAmountModal = true;
    },
    creditChargeSubmit(amount) {
      this.creditChargeSubmitProcess(amount);
      return false;
    },
    async creditChargeSubmitProcess(amount) {
      let token;
      if (!this.me.creditCvvActive) {
        const cvvLength = await payvault.card.getLength('cvv');
        if (cvvLength == 0) {
          toast('セキュリティコードを入力して下さい。', {
            type: 'error',
            transition: 'slide',
            hideProgressBar: true,
            position: 'top-center',
            autoClose: 2000,
          });
          return false;
        }
        if (!(await payvault.card.validateCvv())) {
          toast('セキュリティコードが正しくありません。', {
            type: 'error',
            transition: 'slide',
            hideProgressBar: true,
            position: 'top-center',
            autoClose: 2000,
          });
          return false;
        }

        token = await payvault.card.createToken({
          serviceId: process.env.RAKUTEN_SERVICEID,
          integrationCase: 'cvvToken',
        });
      }
      this.showLoadingOverlay();

      const form = document.createElement('form');
      const data = {
        amount: amount,
        returnTo: 'lastApp',
      };
      if (token) {
        data.token = token;
      }
      this.axios({
        url: '/credit/charge',
        method: 'post',
        data: data,
      }).then((r) => {
        const form = document.createElement('form');
        form.style.display = 'none';
        form.method = 'post';
        form.action = r.data.url;
        const paymentinfo = document.createElement('input');
        paymentinfo.type = 'hidden';
        paymentinfo.name = 'paymentinfo';
        paymentinfo.value = r.data.paymentinfo;
        form.appendChild(paymentinfo);
        const signature = document.createElement('input');
        signature.type = 'hidden';
        signature.name = 'signature';
        signature.value = r.data.signature;
        form.appendChild(signature);
        const keyVersion = document.createElement('input');
        keyVersion.type = 'hidden';
        keyVersion.name = 'key_version';
        keyVersion.value = r.data.keyVersion;
        form.appendChild(keyVersion);
        document.body.appendChild(form);
        form.submit();
      }).catch((e) => {
        console.error(e);
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
        this.hideLoadingOverlay();
      });
    },
    amazonPayChargeSubmit(amount) {
      this.allModalClose();
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/amazonpay',
        data: {
          amount: amount,
          returnTo: 'lastApp',
        },
      }).then((r) => {
        const form = document.createElement('form');
        form.style.display = 'none';
        form.method = 'POST';
        form.action = r.data.url;
        const accessId = document.createElement('input');
        accessId.type = 'hidden';
        accessId.name = 'AccessID';
        accessId.value = r.data.accessId;
        form.appendChild(accessId);
        const token = document.createElement('input');
        token.type = 'hidden';
        token.name = 'Token';
        token.value = r.data.token;
        form.appendChild(token);
        document.body.appendChild(form);
        form.submit();
        setTimeout(() => {
          this.amazonPayAmountModal = false;
          this.loadingOverlay = false;
        }, 5000);
      }).catch((e) => {
        console.error(e);
        alert('通信エラーが発生しました。しばらく待ってから再度お試しください。');
        this.loadingOverlay = false;
      });
    },
    googlePay(amount) {
      this.googlePayAmount = amount;
      this.googlePayAmountModal = true;
      this.$nextTick(() => {
        this.googlePayButton(amount);
      });
    },
    googlePayButton(amount) {
      const googlePayClient = new google.payments.api.PaymentsClient({environment: this.config.GMOPG.googlePayEnvironment});
      const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
      const allowedCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"];

      const tokenizationSpec = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          gateway: this.config.GMOPG.gateway,
          gatewayMerchantId: this.config.GMOPG.shopId,
        }
      };

      const baseClientConfigurateion = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: "CARD",
            tokenizationSpecification: tokenizationSpec,
            parameters: {
              allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
              allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"]
            }
          }
        ]
      };
      const cardPaymentMethod = {
        type: 'CARD',
        tokenizationSpecification: tokenizationSpec,
        parameters: {
          allowedCardNetworks: allowedCardNetworks,
          allowedAuthMethods: allowedCardAuthMethods,
          billingAddressRequired: false,
          billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
          }
        }
      };

      const paymentDataRequest = Object.assign({}, baseClientConfigurateion);
      paymentDataRequest.transactionInfo = {
        totalPriceStatus: 'FINAL',
        totalPrice: amount.toString(),
        currencyCode: 'JPY',
      };
      paymentDataRequest.merchantInfo = {
        merchantId: this.config.GMOPG.googlePayMerchantId,
        merchantName: 'TapFun'
      };

      googlePayClient.isReadyToPay({
        allowedPaymentMethods: ["CARD"]
      }).then((response) => {
        if (response.result) {
          console.log('Payment結果', response.result);
          const button = googlePayClient.createButton({
            buttonColor: 'default',
            buttonType: 'long',
            onClick: onGooglePaymentsBjuttonClicked
          });
          this.$refs.googlePayButton.appendChild(button);

        }
      }).catch(function (err) {
        console.error(err);
      });

      const onGooglePaymentsBjuttonClicked = () => {
        this.loadingOverlay = true;

        googlePayClient.loadPaymentData(paymentDataRequest).then((paymentData) => {
          googlePayClient.prefetchPaymentData(paymentDataRequest);

          const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
          console.log("paymentToken:", paymentToken);
          console.log("paymentData:", paymentData)
          //return new Promise(function(resolve, reject){ })

          processPayment(paymentData)
        }).catch(err => {
          this.loadingOverlay = false;
          console.log(err.statusCode);
          console.log(err.statusMessage);
          if (err.statusCode == 'CANCELED') {
            return;
          }
          alert('エラーが発生しました。もう一度お試しください。');
        });
      }

      const processPayment = (paymentData) => {
        console.log(paymentData);
        const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
        console.log(paymentToken);
        this.axios({
          url: '/googlePayCharge',
          method: 'post',
          data: {
            amount: amount,
            token: paymentToken,
          },
        }).then((res) => {
          this.session();
          this.loadingOverlay = false;
          if (res.data === false) {
            alert('Google Payの決済に失敗しました。');
            return;
          }
          this.googlePayAmountModal = false;
          this.googlePayChargedModal = true;
          this.googlePayChargedAmount = parseInt(amount);
        }).catch(err => {
          console.error(err);
          this.loadingOverlay = false;
          this.googlePayConfirmModal = false;
          alert('通信エラーが発生しました。チャージが完了している可能性があるため、ブラウザをリロードして確認してください。');
          this.session();
        });
      }

    },
    registerModalGoogle() {
      this.allModalClose();
      location.href = '/player/login/google?context=play';
    },
    rakutenCreditModalClose() {
      console.log('rakutenCreditModalClose');
      if (this.purchaseModal) {
        this.purchaseModalOpen();
      }
    },
  }
}
</script>

